export default {
  data() {
    return {
      pageNumber: 1,
      sizeperpage: 10,
      maxVisibleButtons: 3,
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      dataTable: [],
    };
  },
  methods: {
    nextPage() {
      if (this.pageNumber < this.pageCount) {
        this.pageNumber++;
      }
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber--;
      }
    },
    sortBy: function(key) {
      console.log(this.sortOrders, "sortOrders");
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      console.log(this.sortOrders, "sortOrders");
    },
    goToFirstPage() {
      this.pageNumber = 1;
    },
    goToLastPage() {
      this.pageNumber = this.pageCount;
    },
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
    },
    onchange({ target: { value } }) {
      this.sizeperpage = +value;
    },
    handleSearch({ target: { value } }) {
      this.searchQuery = value;
    },
  },
  created() {
    let sortOrders = {};
    if (this.tableColumns) {
      this.tableColumns.forEach(function(key) {
        sortOrders[key[1]] = 1;
      });
      this.sortOrders = sortOrders;
    }
  },
  computed: {
    pageCount() {
      let s = this.sizeperpage;

      let data = this.dataTable;
      let l = data.length;
      let count = Math.ceil(l / s);
      let filterKey = this.searchQuery.toLowerCase();
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
        l = data.length;
        count = Math.ceil(l / s);
      }

      return count;
    },
    paginatedData() {
      let start = (this.pageNumber - 1) * parseFloat(this.sizeperpage);
      let end =
        (this.pageNumber - 1) * parseFloat(this.sizeperpage) +
        parseFloat(this.sizeperpage);
      let data = this.dataTable;
      let sortKey = this.sortKey;
      let filterKey = this.searchQuery.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }
      data = data.slice(start, end);
      return data;
    },
    startPage() {
      // When on the first page
      if (this.pageNumber === 1) {
        return 2;
      }
      // When on the last page
      if (this.pageNumber === this.pageCount) {
        return this.pageCount - this.maxVisibleButtons;
      }
      // When in between
      return this.pageNumber - 1;
    },
    pages() {
      const range = [];

      if (this.startPage === 1) {
        for (
          let i = this.startPage + 1;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else if (
        this.startPage ===
        this.pageCount - this.maxVisibleButtons + 1
      ) {
        for (
          let i = this.startPage;
          i <=
          Math.min(
            this.startPage + this.maxVisibleButtons - 1,
            this.pageCount - 1
          );
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      } else {
        for (
          let i = this.startPage;
          i <=
          Math.min(this.startPage + this.maxVisibleButtons - 1, this.pageCount);
          i++
        ) {
          range.push({
            name: i,
            isDisabled: i === this.pageNumber,
          });
        }
      }

      return range;
    },
  },
  watch: {
    paginatedData: {
      handler() {
        if (this.paginatedData.length === 0) {
          this.dataCheck = false;
        } else this.dataCheck = true;
      },
    },
    sizeperpage() {
      this.pageNumber = 1;
    },
  },
};
